var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as BaseAvatar from "./BaseAvatar";
const UserIcon = () => (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", children: [_jsx("title", { children: "User Icon" }), _jsx("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }), _jsx("circle", { cx: "12", cy: "7", r: "4" })] }));
const getInitials = (name = "") => name
    .split(" ")
    .map((part) => part[0])
    .splice(0, 2)
    .join("")
    .toUpperCase();
export const Avatar = forwardRef((props, ref) => {
    const { name, src } = props, rootProps = __rest(props, ["name", "src"]);
    return (_jsxs(BaseAvatar.Root, Object.assign({ ref: ref }, rootProps, { children: [_jsx(BaseAvatar.Fallback, { children: getInitials(name) || _jsx(UserIcon, {}) }), _jsx(BaseAvatar.Image, { src: src, alt: name })] })));
});
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map